/**
 * 认证服务 - 登录、登出相关 API
 */

import api from '../../api';
import type { Result } from '../../types';
import type { User } from '../../../types';

export const login = (username: string, password: string): Promise<Result<{ token: string; user: User }>> => {
  return api.post('/auth/login', { username, password }, { skipCsrf: true });
};

export const logout = (): Promise<Result<void>> => {
  return api.post('/auth/logout', null, { skipCsrf: true });
};

export const getCurrentUser = (): Promise<Result<User>> => {
  return api.get('/auth/currentUser');
};

export const updatePassword = (oldPassword: string, newPassword: string): Promise<Result<void>> => {
  return api.post('/auth/updatePassword', { oldPassword, newPassword });
};
